import { connect } from 'react-redux';

import { formStatusSelector } from 'selectors/validation';
import { updateApplication } from '@redux/modules/application/actions';
import { rootSelectors } from '@redux/modules/selectors';

const connectPackageSection = (Component) => {
  /** @param {import('types/state').RootState} state */
  const mapStateToProps = (state) => {
    const { application, save } = state;
    const {
      Settings, Identification, History, Submission
    } = application;
    const {
      isSubmitting,
      submissionType,
      submissionHasError,
      submissionError,
      statusResponse,
      submissionComplete
    } = save;

    return {
      ...formStatusSelector(state),
      Application: application,
      Identification,
      History,
      Submission,
      Settings,
      isLocked: rootSelectors.application.getIsLocked(state),
      isComplete: rootSelectors.form.areAllSectionsCompleted(state),
      initialValidateFormCompleted: state.form.initialValidateFormCompleted,
      isSubmitting,
      submissionType,
      submissionHasError,
      submissionError,
      statusResponse,
      submissionComplete,
    };
  };

  const mapDispatchToProps = {
    updateApplication,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};

export default connectPackageSection;
